module.exports = __WEBPACK_EXTERNAL_MODULE_79__;


//////////////////
// WEBPACK FOOTER
// external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"}
// module id = 79
// module chunks = 0